import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from '../shared/material.module';
import { SharedModule } from '../shared/shared.module';
import { CaAlertPanel } from './alert-panel/alert-panel';
import { CaButtonComponent } from './button/button';
import { CaDismissibleHint } from './dismissible-hint/dismissible-hint.component';
import { CaInputComponent } from './input/input.component';
import { CaLargeCard } from './large-card/large-card.component';
import { CaNarrowPage } from './narrow-page/narrow-page.component';
import { CaPasswordInputComponent } from './password-input/password-input.component';
import { CaPhoneNumberInputComponent } from './phone-number-input/phone-number-input.component';
import { CaRaisedButtonComponent } from './raised-button/raised-button';
import { CaSeparatorComponent } from './separator/separator.component';
import { CaVerificationInputComponent } from './verification-input/verification-input.component';
import { CaWidePage } from './wide-page/wide-page.component';
import { CaPageHeaderComponent } from './page-header/page-header.component';
import { CaInfoCardComponent } from './info-card/info-card.component';
import { CaCountComparisonCardComponent } from './count-comparison-card/count-comparison-card.component';
import { CaFormFieldComponent } from './form-field/form-field.component';

export const components = [
  CaAlertPanel,
  CaButtonComponent,
  CaCountComparisonCardComponent,
  CaFormFieldComponent,
  CaRaisedButtonComponent,
  CaInputComponent,
  CaInfoCardComponent,
  CaLargeCard,
  CaNarrowPage,
  CaPageHeaderComponent,
  CaSeparatorComponent,
  CaWidePage,
  CaPhoneNumberInputComponent,
  CaVerificationInputComponent,
  CaPasswordInputComponent,
  CaDismissibleHint,
];

@NgModule({
  imports: [SharedModule, CommonModule, MaterialModule, FormsModule, TranslateModule],
  declarations: [...components],
  exports: [...components],
})
export class CaDesignModule {}
